import React from 'react';
import PropTypes from 'prop-types';
import './NotificationBadge.css';
import { ReactComponent as Badge } from './badge.svg';

const NotificationBadge = ({ unreadCount }) => {
    return unreadCount !== 0 ? (
        <div className="badge__container">
            <Badge className="badge__icon" />
            <span className="badge__counter">{unreadCount}</span>
        </div>
    ) : null;
};

NotificationBadge.propTypes = {
    unreadCount: PropTypes.number.isRequired,
};

export default React.memo(NotificationBadge);
